export type FlowValueFormat = 'currency' | 'number'

const SCALES = [
  { size: 1_000_000_000, suffix: 'B', decimals: 2 },
  { size: 1_000_000, suffix: 'M', decimals: 2 },
  { size: 1_000, suffix: 'K', decimals: 1 },
]

// "$1.84M", "$329.7K", "$40"; a trailing ".0" or "0" is dropped.
export function formatFlowAmount(
  value: number,
  valueFormat: FlowValueFormat = 'currency',
): string {
  const prefix = valueFormat === 'currency' ? '$' : ''
  const sign = value < 0 ? '-' : ''
  const size = Math.abs(value)
  const scale = SCALES.find((candidate) => scaledTo(size, candidate) >= 1)
  if (!scale) return `${sign}${prefix}${Math.round(size)}`
  return `${sign}${prefix}${scaledTo(size, scale)}${scale.suffix}`
}

// Rounds before comparing, so 999,950 reads "$1M" and not "$1000K".
function scaledTo(size: number, scale: (typeof SCALES)[number]): number {
  return Number((size / scale.size).toFixed(scale.decimals))
}

export function formatCount(count: number): string {
  return count.toLocaleString('en-US')
}

export function formatShare(part: number, whole: number): string {
  if (whole <= 0) return '0%'
  const percent = (part / whole) * 100
  if (percent > 0 && percent < 1) return '<1%'
  return `${Math.round(percent)}%`
}
